/* ============================================================
   FAGOTTINA — JavaScript principale
   File: assets/fagottina.js
   Da richiamare in theme.liquid con:
   <script src="{{ 'fagottina.js' | asset_url }}" defer></script>
   ============================================================ */

(function () {
  'use strict';

  /* ── HAMBURGER MENU MOBILE ─────────────────────────────────
     Apre/chiude il menu mobile senza ID duplicati.
     Usa data-fg-menu-btn come hook — mai onclick inline.
     Gestisce aria-expanded per accessibilità screen reader.
  ──────────────────────────────────────────────────────────── */
  const menuBtn    = document.querySelector('[data-fg-menu-btn]');
  const mobileNav  = document.getElementById('fg-mobile-nav');
  if (menuBtn && mobileNav) {
    menuBtn.addEventListener('click', () => {
      const isOpen = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!isOpen));
      menuBtn.setAttribute('aria-label', isOpen ? 'Apri menu' : 'Chiudi menu');
      menuBtn.querySelector('i').className = isOpen ? 'ti ti-menu-2' : 'ti ti-x';
      mobileNav.classList.toggle('open', !isOpen);
      if (isOpen) {
        mobileNav.setAttribute('hidden', '');
      } else {
        mobileNav.removeAttribute('hidden');
      }
    });
    /* Chiudi su click fuori */
    document.addEventListener('click', e => {
      if (!menuBtn.contains(e.target) && !mobileNav.contains(e.target)) {
        menuBtn.setAttribute('aria-expanded', 'false');
        menuBtn.setAttribute('aria-label', 'Apri menu');
        menuBtn.querySelector('i').className = 'ti ti-menu-2';
        mobileNav.classList.remove('open');
        mobileNav.setAttribute('hidden', '');
      }
    });
  }

  /* ── CURSOR CUSTOM (solo desktop con mouse fisico) ── */
  const mq = window.matchMedia('(hover: hover) and (pointer: fine)');
  if (mq.matches) {
    const cur  = document.getElementById('fg-cur');
    const curR = document.getElementById('fg-cur-r');
    if (cur && curR) {
      let mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', e => {
        mx = e.clientX; my = e.clientY;
        cur.style.left = mx - 4 + 'px';
        cur.style.top  = my - 4 + 'px';
      });
      (function tick() {
        rx += (mx - rx) * 0.12;
        ry += (my - ry) * 0.12;
        curR.style.left = rx - 16 + 'px';
        curR.style.top  = ry - 16 + 'px';
        requestAnimationFrame(tick);
      })();
      document.querySelectorAll('a, button, .cat-slide, .off-card, .sca-header, .cc, .cb, .rev-card, .gall-item').forEach(el => {
        el.addEventListener('mouseenter', () => { cur.style.transform = 'scale(2.5)'; curR.style.opacity = '.2'; });
        el.addEventListener('mouseleave', () => { cur.style.transform = 'scale(1)';   curR.style.opacity = '.5'; });
      });
    }
  }

  /* ── CAROSELLO DINAMICO V2 — drag, autoplay, progress, dots ── */
  (function () {
    const track    = document.getElementById('fg-ctrack');
    const viewport = document.getElementById('fg-car-viewport');
    const dotsC    = document.getElementById('fg-cdots');
    const btnPrev  = document.getElementById('fg-cprev');
    const btnNext  = document.getElementById('fg-cnext');
    const progress = document.getElementById('fg-car-progress');
    if (!track || !viewport) return;

    const AUTOPLAY_MS = 4000;
    const slides = Array.from(track.querySelectorAll('.cat-slide'));
    const total  = slides.length;
    let idx = 0, autoTimer, progressTimer;

    /* ── visibili in base a viewport ── */
    function visibleCount() {
      const w = viewport.offsetWidth;
      if (w <= 480) return 1;
      if (w <= 760) return 2;
      return 4;
    }

    function slideW() {
      return slides[0] ? slides[0].offsetWidth + 3 : 0;
    }

    function maxIdx() {
      return Math.max(0, total - visibleCount());
    }

    /* ── Dots ── */
    function buildDots() {
      dotsC.innerHTML = '';
      const nd = Math.ceil(total / visibleCount());
      for (let i = 0; i < nd; i++) {
        const d = document.createElement('button');
        d.className = 'cdot' + (i === 0 ? ' active' : '');
        d.setAttribute('aria-label', 'Vai alla slide ' + (i + 1));
        d.addEventListener('click', () => goTo(i * visibleCount()));
        dotsC.appendChild(d);
      }
    }

    function updateDots() {
      const dots = dotsC.querySelectorAll('.cdot');
      const activeDot = Math.floor(idx / visibleCount());
      dots.forEach((d, i) => d.classList.toggle('active', i === activeDot));
    }

    /* ── Progress bar ── */
    function startProgress() {
      if (!progress) return;
      clearInterval(progressTimer);
      progress.style.transition = 'none';
      progress.style.width = '0';
      requestAnimationFrame(() => {
        progress.style.transition = `width ${AUTOPLAY_MS}ms linear`;
        progress.style.width = '100%';
      });
    }

    /* ── goTo ── */
    function goTo(n, smooth) {
      idx = Math.max(0, Math.min(n, maxIdx()));
      if (smooth === false) track.classList.add('no-transition');
      track.style.transform = `translateX(-${idx * slideW()}px)`;
      if (smooth === false) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => track.classList.remove('no-transition'));
        });
      }
      updateDots();
      if (btnPrev) btnPrev.disabled = idx === 0;
      if (btnNext) btnNext.disabled = idx >= maxIdx();
    }

    /* ── Autoplay ── */
    function startAutoplay() {
      clearInterval(autoTimer);
      startProgress();
      autoTimer = setInterval(() => {
        const next = idx >= maxIdx() ? 0 : idx + 1;
        goTo(next);
        startProgress();
      }, AUTOPLAY_MS);
    }

    function resetAutoplay() {
      clearInterval(autoTimer);
      startAutoplay();
    }

    /* ── Frecce ── */
    if (btnPrev) btnPrev.addEventListener('click', () => { goTo(idx - 1); resetAutoplay(); });
    if (btnNext) btnNext.addEventListener('click', () => { goTo(idx + 1); resetAutoplay(); });

    /* ── Drag / Swipe ── */
    let dragStartX = 0, dragCurrentX = 0, dragging = false, dragStartIdx = 0;

    function onDragStart(x) {
      dragging = true;
      dragStartX = x;
      dragCurrentX = x;
      dragStartIdx = idx;
      clearInterval(autoTimer);
      track.classList.add('no-transition');
      viewport.classList.add('is-dragging');
    }
    function onDragMove(x) {
      if (!dragging) return;
      dragCurrentX = x;
      const delta = dragStartX - dragCurrentX;
      track.style.transform = `translateX(-${dragStartIdx * slideW() + delta}px)`;
    }
    function onDragEnd() {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove('is-dragging');
      track.classList.remove('no-transition');
      const delta = dragStartX - dragCurrentX;
      const threshold = slideW() * 0.25;
      if (Math.abs(delta) > threshold) {
        goTo(delta > 0 ? dragStartIdx + 1 : dragStartIdx - 1);
      } else {
        goTo(dragStartIdx);
      }
      startAutoplay();
    }

    /* Mouse */
    viewport.addEventListener('mousedown',  e => onDragStart(e.clientX));
    viewport.addEventListener('mousemove',  e => onDragMove(e.clientX));
    viewport.addEventListener('mouseup',    onDragEnd);
    viewport.addEventListener('mouseleave', onDragEnd);
    /* Touch */
    viewport.addEventListener('touchstart', e => onDragStart(e.touches[0].clientX), { passive: true });
    viewport.addEventListener('touchmove',  e => onDragMove(e.touches[0].clientX),  { passive: true });
    viewport.addEventListener('touchend',   onDragEnd);

    /* Pausa hover */
    viewport.addEventListener('mouseenter', () => clearInterval(autoTimer));
    viewport.addEventListener('mouseleave', () => startAutoplay());

    /* Previeni click su drag */
    slides.forEach(s => {
      s.addEventListener('click', e => {
        if (Math.abs(dragStartX - dragCurrentX) > 8) e.preventDefault();
      });
    });

    /* Keyboard */
    document.addEventListener('keydown', e => {
      if (e.key === 'ArrowLeft')  { goTo(idx - 1); resetAutoplay(); }
      if (e.key === 'ArrowRight') { goTo(idx + 1); resetAutoplay(); }
    });

    /* Resize */
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => { buildDots(); goTo(idx, false); }, 150);
    });

    /* ── Init ── */
    buildDots();
    goTo(0, false);
    startAutoplay();
  })();

  /* ── ACCORDION SOTTOCATEGORIE ── */
  document.querySelectorAll('.sca-header').forEach(header => {
    header.addEventListener('click', () => {
      const item     = header.closest('.sca-item');
      const wasOpen  = item.classList.contains('open');
      document.querySelectorAll('.sca-item').forEach(i => i.classList.remove('open'));
      if (!wasOpen) item.classList.add('open');
    });
  });

  /* ── SCROLL REVEAL ── */
  const revealObs = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.style.opacity    = '1';
        e.target.style.transform  = 'translateY(0)';
        revealObs.unobserve(e.target);
      }
    });
  }, { threshold: 0.1 });

  document.querySelectorAll(
    '.cat-slide, .off-card, .sca-item, .rev-card, .cc, .cb, .gall-item, .cs-circle, .cs-stats'
  ).forEach(el => {
    el.style.opacity   = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    revealObs.observe(el);
  });

  /* ── COOKIE BANNER ── */
  const ck    = document.getElementById('fg-cookie');
  const ckBtn = document.getElementById('fg-cookie-btn');
  if (ck && ckBtn) {
    ckBtn.addEventListener('click', () => {
      ck.style.display = 'none';
      try { localStorage.setItem('fg_cookie_ok', '1'); } catch(_) {}
    });
    try {
      if (localStorage.getItem('fg_cookie_ok')) ck.style.display = 'none';
    } catch(_) {}
  }

  /* ── NEWSLETTER (feedback visivo) ── */
  const nlBtn = document.getElementById('fg-nl-btn');
  const nlInput = document.getElementById('fg-nl-email');
  if (nlBtn && nlInput) {
    nlBtn.addEventListener('click', () => {
      if (nlInput.value.trim()) {
        nlBtn.textContent = 'Grazie!';
        setTimeout(() => { nlBtn.textContent = 'Iscriviti'; }, 2500);
      }
    });
  }

  /* ── AJAX CART — form offerte ──────────────────────────────
     Intercetta i form [data-fg-cart-form] e aggiunge al
     carrello via /cart/add.js senza ricaricare la pagina.
     Aggiorna il contatore nel header (span dentro .bcart).
  ──────────────────────────────────────────────────────────── */
  function fgUpdateCartCount() {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        document.querySelectorAll('[data-fg-cart-count]').forEach(el => {
          el.textContent = data.item_count;
        });
        /* Aggiorna anche il testo dentro .bcart se presente */
        const bcart = document.querySelector('.bcart');
        if (bcart) {
          bcart.innerHTML = bcart.innerHTML.replace(
            /\(\d+\)/,
            '(' + data.item_count + ')'
          );
        }
      })
      .catch(() => {});
  }

  document.querySelectorAll('[data-fg-cart-form]').forEach(form => {
    form.addEventListener('submit', e => {
      const btn = form.querySelector('button[type="submit"]');
      /* Se il form ha return_to="/cart" lascia il comportamento nativo */
      if (form.querySelector('input[name="return_to"]')) return;

      e.preventDefault();

      const variantId = form.querySelector('input[name="id"]').value;
      const qty       = form.querySelector('input[name="quantity"]').value || 1;

      btn.disabled    = true;
      btn.textContent = '…';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: parseInt(qty, 10) })
      })
        .then(r => {
          if (!r.ok) throw new Error('Cart error ' + r.status);
          return r.json();
        })
        .then(() => {
          btn.textContent = '✓ Aggiunto';
          btn.style.background = 'var(--navy)';
          btn.style.color      = 'var(--gold3)';
          fgUpdateCartCount();
          setTimeout(() => {
            btn.disabled        = false;
            btn.textContent     = btn.dataset.originalLabel || 'Al carrello';
            btn.style.background = '';
            btn.style.color      = '';
          }, 2200);
        })
        .catch(() => {
          btn.disabled    = false;
          btn.textContent = 'Errore — riprova';
          setTimeout(() => { btn.textContent = btn.dataset.originalLabel || 'Al carrello'; }, 2000);
        });
    });

    /* Salva etichetta originale per il ripristino */
    const btn = form.querySelector('button[type="submit"]');
    if (btn) btn.dataset.originalLabel = btn.textContent.trim();
  });

  /* ── VARIANT SWITCHER — select offerte ─────────────────────
     Quando l'utente cambia variante dal <select>, aggiorna
     l'input hidden name="id" nel form corrispondente e
     mostra il prezzo della variante selezionata.
  ──────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-fg-variant-select]').forEach(sel => {
    sel.addEventListener('change', () => {
      const newVariantId = sel.value;
      const card = sel.closest('.off-card');
      if (!card) return;

      /* Aggiorna variant ID nel form */
      const hiddenId = card.querySelector('input[name="id"]');
      if (hiddenId) hiddenId.value = newVariantId;
      const btnVariant = card.querySelector('[data-variant-id]');
      if (btnVariant) btnVariant.dataset.variantId = newVariantId;

      /* Aggiorna prezzo via /variants/{id}.js */
      fetch('/variants/' + newVariantId + '.js')
        .then(r => r.json())
        .then(v => {
          const priceEl   = card.querySelector('.price-new');
          const compareEl = card.querySelector('.price-old');
          if (priceEl) priceEl.textContent = fgFormatMoney(v.price);
          if (compareEl) {
            if (v.compare_at_price > v.price) {
              compareEl.textContent = fgFormatMoney(v.compare_at_price);
              compareEl.style.display = '';
            } else {
              compareEl.style.display = 'none';
            }
          }
          /* Disponibilità */
          const submitBtn = card.querySelector('[data-fg-cart-form] button[type="submit"]');
          if (submitBtn) {
            submitBtn.disabled = !v.available;
            submitBtn.textContent = v.available
              ? (submitBtn.dataset.originalLabel || 'Al carrello')
              : 'Esaurito';
          }
        })
        .catch(() => {});
    });
  });

  /* Helper: formatta centesimi in stringa prezzo italiana */
  function fgFormatMoney(cents) {
    return (cents / 100).toLocaleString('it-IT', {
      style: 'currency',
      currency: window.Shopify && window.Shopify.currency
        ? window.Shopify.currency.active
        : 'EUR'
    });
  }

  /* ── PAGINA PRODOTTO: variant switcher completo ────────────
     Legge il JSON varianti iniettato dal Liquid nel tag
     <script type="application/json" data-fg-variants-json>.
     Nessuna chiamata API aggiuntiva — tutto già nel DOM.
  ──────────────────────────────────────────────────────────── */
  document.querySelectorAll('[data-fg-product-form]').forEach(form => {
    const productId  = form.dataset.productId;
    const jsonEl     = form.querySelector('[data-fg-variants-json]');
    if (!jsonEl) return;

    let variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch(_) { return; }

    const variantInput = form.querySelector('[data-fg-variant-id]');
    const priceEl      = form.closest('[data-fg-product-section]')
                            ?.querySelector('[data-fg-price]');
    const compareEl    = form.closest('[data-fg-product-section]')
                            ?.querySelector('[data-fg-compare]');
    const cartBtn      = form.querySelector('[data-fg-cart-btn]');
    const mainImg      = document.getElementById('fg-product-img');

    /* Stato selezioni correnti per le opzioni */
    const currentOpts = {};

    function findVariant() {
      return variants.find(v =>
        Object.entries(currentOpts).every(([idx, val]) =>
          v['option' + (parseInt(idx) + 1)] === val
        )
      ) || variants[0];
    }

    function applyVariant(v) {
      if (!v) return;

      /* Aggiorna hidden input ID */
      if (variantInput) variantInput.value = v.id;
      if (cartBtn)      cartBtn.dataset.variantId = v.id;

      /* Aggiorna prezzi */
      if (priceEl) priceEl.textContent = fgFormatMoney(v.price);
      if (compareEl) {
        if (v.compare_at_price > v.price) {
          compareEl.textContent  = fgFormatMoney(v.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.style.display = 'none';
        }
      }

      /* Aggiorna immagine se la variante ne ha una */
      if (mainImg && v.featured_image) {
        mainImg.src = v.featured_image.src;
        mainImg.alt = v.featured_image.alt;
      }

      /* Aggiorna stato pulsante */
      if (cartBtn) {
        cartBtn.disabled    = !v.available;
        cartBtn.textContent = v.available ? 'Aggiungi al carrello' : 'Prodotto esaurito';
        if (v.available) {
          cartBtn.innerHTML = '<i class="ti ti-shopping-bag" aria-hidden="true"></i> Aggiungi al carrello';
        }
      }

      /* Aggiorna URL senza ricaricare (best practice Shopify) */
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    /* Inizializza stato opzioni dalla selezione corrente */
    form.querySelectorAll('[data-fg-option-btn].selected').forEach(btn => {
      currentOpts[btn.dataset.optionIndex] = btn.dataset.optionValue;
    });

    /* Click su pulsanti opzione */
    form.querySelectorAll('[data-fg-option-btn]').forEach(btn => {
      btn.addEventListener('click', () => {
        if (btn.classList.contains('unavailable')) return;

        const idx = btn.dataset.optionIndex;
        currentOpts[idx] = btn.dataset.optionValue;

        /* Aggiorna UI pulsanti (deseleziona gruppo, seleziona clicked) */
        form.querySelectorAll(`[data-option-index="${idx}"] [data-fg-option-btn]`)
            .forEach(b => {
              b.classList.toggle('selected', b === btn);
              b.setAttribute('aria-checked', b === btn ? 'true' : 'false');
            });

        /* Aggiorna label valore selezionato */
        const lbl = form.querySelector(`[data-fg-opt-current="${idx}"]`);
        if (lbl) lbl.textContent = btn.dataset.optionValue;

        applyVariant(findVariant());
      });
    });
  });

  /* ── CONTROLLI QUANTITÀ +/− (pagina prodotto) ─────────── */
  document.querySelectorAll('[data-fg-qty-minus], [data-fg-qty-plus]').forEach(btn => {
    btn.addEventListener('click', () => {
      const isPlus = btn.hasAttribute('data-fg-qty-plus');
      const input  = btn.closest('.fg-product__qty-wrap, .fg-cart__item-qty')
                        ?.querySelector('input[type="number"]');
      if (!input) return;
      const current = parseInt(input.value, 10) || 1;
      const min     = parseInt(input.min, 10) || 0;
      const max     = parseInt(input.max, 10) || 9999;
      input.value   = Math.min(max, Math.max(min, isPlus ? current + 1 : current - 1));
    });
  });

  /* ── THUMBNAILS GALLERIA PRODOTTO ──────────────────────── */
  document.querySelectorAll('[data-fg-thumb]').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const mainImg = document.getElementById('fg-product-img');
      if (mainImg) {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt;
      }
      document.querySelectorAll('[data-fg-thumb]').forEach(t =>
        t.classList.toggle('active', t === thumb)
      );
    });
  });

  /* ── RIMOZIONE ITEM CARRELLO via AJAX ──────────────────── */
  document.querySelectorAll('[data-fg-remove-item]').forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const line = parseInt(link.dataset.fgRemoveItem, 10);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      })
        .then(r => r.json())
        .then(() => window.location.reload())
        .catch(() => { window.location.href = link.href; });
    });
  });

})();

  /* ── CAROSELLO AUTO-AVANZAMENTO ── */
  if (track) {
    let autoIdx = 0;
    setInterval(() => {
      const perView = window.innerWidth <= 480 ? 1 : window.innerWidth <= 960 ? 2 : 4;
      const mx = track.querySelectorAll('.cat-slide').length - perView;
      autoIdx = autoIdx >= mx ? 0 : autoIdx + 1;
      const w = track.querySelectorAll('.cat-slide')[0]?.offsetWidth + 3 || 0;
      track.style.transform = `translateX(-${autoIdx * w}px)`;
    }, 4000);
  }

  /* ── NEWSLETTER V8 — feedback + codice sconto ── */
  const nlBtnV8 = document.getElementById('fg-nl-btn');
  if (nlBtnV8) {
    nlBtnV8.addEventListener('click', () => {
      const nome  = document.getElementById('fg-nl-nome')?.value?.trim();
      const email = document.getElementById('fg-nl-email')?.value?.trim();
      if (!email || !email.includes('@')) return;
      const card = nlBtnV8.closest('.nl-card');
      if (card) {
        card.innerHTML = `
          <div style="text-align:center;padding:20px 0">
            <i class="ti ti-circle-check" style="font-size:44px;color:var(--gold);display:block;margin-bottom:14px"></i>
            <div style="font-family:var(--fsc);font-size:36px;color:var(--navy);margin-bottom:10px">Benvenuta${nome ? ', ' + nome : ''}!</div>
            <p style="font-family:var(--fd);font-size:15px;font-style:italic;color:var(--muted);line-height:1.7;margin-bottom:16px">Controlla la tua email — ti abbiamo inviato il codice sconto!</p>
            <div style="background:var(--gold3);border:2px solid var(--gold);font-family:var(--fs);font-size:16px;font-weight:600;letter-spacing:.22em;color:var(--navy);padding:12px 24px;display:inline-block;margin-bottom:10px">FAGOTTINA10</div>
            <p style="font-family:var(--fd);font-size:13px;font-style:italic;color:var(--muted)">10% di sconto sul primo ordine</p>
          </div>`;
      }
    });
  }

  /* ── SCROLL REVEAL — aggiungi nuovi elementi ── */
  document.querySelectorAll('.tut-card, .cp-workshop, .pub-book, .pub-dig-card, .h-step').forEach(el => {
    el.style.opacity   = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = 'opacity .6s ease, transform .6s ease';
    revealObs.observe(el);
  });

